// extracted by mini-css-extract-plugin
export default {"middleLayer":"middleLayer_middleLayer__xMP32","boardRow":"middleLayer_boardRow__CrCFX","title":"middleLayer_title__EeXou"};